import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumberString, IsOptional, IsString, Matches, MaxLength, ValidateNested } from "class-validator";
import { LabellingSamples } from "../entities/labelling-samples.entity";
import { LabellingSamplesDTO } from "./labelling-samples.dto";


export class LabellingData {
    @ApiPropertyOptional()
    labellingId: number;

    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    saleOrderItemId: number;

    @ApiProperty()
    @IsString()
    lotNumber: string;

    @ApiProperty()
    @IsString()
    labellingDate: Date;

    @ApiProperty()
    @IsString()
    traceabilityCode: string;

    @ApiProperty()
    country: string;

    @ApiProperty()
    totalMCs: string;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    updatedAt: Date;
    @ApiProperty()


    updatedUser: string;
    versionFlag: number;

    @ApiProperty({ type: [LabellingSamplesDTO] })
    labellingSamplesInfo: LabellingSamplesDTO[];

}